import './NotificationPopupOverlay.less';

import React, { useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import NotificationPopup from 'nike-ui/src/components/notification-popup/view/NotificationPopup';
import { useInterval } from 'nike-ui/src/common/hooks/useInterval';
import { changeStatusOfNotificationPopup } from '@/notification-popup/handlers';
import { navigate } from '@/routing';
import { TOURNAMENTS } from '@/routing/routes';
import { getTournamentsPriority$ } from 'nike-ui/src/components/notification-popup/reframe/h&s';
import { Active } from 'nike-ui/src/components/tournaments/TournamentStatus';

function NotificationOverlay() {
    const [elapsed, setElapsed] = useState(10);
    const { derefSub } = useReframe();
    const tournaments = derefSub(getTournamentsPriority$);
    const { id, status } = tournaments.first().toJS();
    useInterval(
        () => {
            setElapsed(elapsed - 1);
            if (elapsed - 1 <= 0) {
                return dispatch(changeStatusOfNotificationPopup(id, status));
            }
        },
        elapsed > 0 ? 1000 : null
    );

    return (
        <div className="notification-popup-overlay p-fix flex full-width justify-center">
            <NotificationPopup
                onClick={() => navigate(TOURNAMENTS)}
                onCloseAction={() => dispatch(changeStatusOfNotificationPopup(id, status))}
                active={status === Active}
            />
        </div>
    );
}

export default NotificationOverlay;
